import React from 'react';

// Multibrand-UI Components
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import UnitsMF from 'app/shared/components/postingPath/UnitsMF';

// Stylesheets
import '../utils.scss';

const noop = () => {};

const UnitsSection = ({
    formData,
    isMobile,
    isInputFormDisabled,
    canEditTourOverwrite,
}) => (
    <div className="UnitsSection">
        <Row>
            <Col>
                <Text className="PostingPath-module-title" type="h2">
                    Manage units
                </Text>
            </Col>
        </Row>
        <a className="EditListingPage-anchor" id="units" />
        <UnitsMF
            canAddUnits={false}
            canEditTourOverwrite={canEditTourOverwrite}
            floorPlanIndex={null}
            floorplans={formData.floorplans}
            formData={formData}
            isDisabled={formData.vaultware || isInputFormDisabled}
            isMobile={isMobile}
            onAddUnit={noop}
            onRemoveUnit={noop}
            onToggleActive={noop}
            units={formData.units}
            updateFormData={noop}
            updateParentFloorPlanPrice={noop}
            validateFloorPlan={noop}
            updateStatusMessage={noop}
        />
    </div>
);

export default UnitsSection;
